import { useCallback, useEffect, useMemo, useState } from "react";
import { getIn, useFormikContext } from "formik";
import { IRenter } from "@/types/renter.type";
import { getRenterById } from "@/common/services/renters.api";

export function useDepositLogic() {
  const { values } = useFormikContext();
  const formik = useFormikContext();
  const renter = getIn(values, 'renterId');

  const [paymentMethod, setPaymentMethod] = useState('-');
  const [deposit, setDeposit] = useState(0);
  const [renterData, setRenterData] = useState<IRenter | null>(null);
  const [easyDeposit, setEasyDeposit] = useState(false);

  // Carrega dados do locatário
  useEffect(() => {
    async function loadRenterData(renterId: string) {
      if (!renterId) return;
      const { data, ok } = await getRenterById(renter);
      if (ok) {
        setRenterData(data as IRenter);
      }
    }
    if (renter) loadRenterData(renter);
  }, [renter]);

  // Calcula valor do caução
  const calculateCaucaoValue = useCallback(() => {
    const valueDeposit = renterData?.booking?.depositValue || 0;
    const typePayment = renterData?.booking?.typePayment || "";

    if (typePayment === 'CRÉDITO' || typePayment === 'PIX') {
      const depositValue = parseFloat(valueDeposit.toString());
      if (!isNaN(depositValue)) {
        const caucaoValue = typePayment === 'CRÉDITO' ? 650 : 600;
        return caucaoValue - depositValue;
      }
    }
    return 0;
  }, [renterData?.booking?.depositValue, renterData?.booking?.typePayment]);

  // Calcula depósito com taxa
  const calculateDeposit = useCallback((paymentMethod: string, previousPaymentMethod: string, newValue: number) => {
    let valueCredit = newValue;
    if (paymentMethod === 'CREDIT_CARD') {
      if (previousPaymentMethod === 'PIX' || previousPaymentMethod === '') {
        valueCredit += 50;
      }
    }
    return valueCredit;
  }, []);

  // Handler para mudança no valor do depósito
  const handleDepositChange = useCallback((numericValue: number) => {
    const typePayment = renterData?.booking?.typePayment || "";
    const valueCredit = calculateDeposit(paymentMethod, typePayment, numericValue);
    setDeposit(valueCredit);
    formik.setFieldValue('valueDepositCredit', valueCredit);
  }, [paymentMethod, renterData?.booking?.typePayment, formik, calculateDeposit]);

  const valueCaucao = useMemo(() => calculateCaucaoValue(), [calculateCaucaoValue]);
  const valueDeposit = renterData?.booking?.depositValue || 0;
  const typePayment = renterData?.booking?.typePayment || "";

  return {
    // Estados
    paymentMethod,
    deposit,
    renterData,
    easyDeposit,
    valueCaucao,
    valueDeposit,
    typePayment,

    // Setters
    setPaymentMethod,
    setEasyDeposit,

    // Handlers
    handleDepositChange,
  };
}